import ObjectCache from './CacheService';
import LogicBaseAppLikeApi from '../server/LogicBaseAppLikeApi';
import UserAccount from '../UserAccount';
import LogicBaseAppLike from '../../models/logicbaseapplike';

class LogicBaseAppLikeCache extends ObjectCache {
  api = LogicBaseAppLikeApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseAppLike(results._id, results.fr, results.a);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseAppLikeCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
